import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=167e36b0&scoped=true"
import script from "./ChatContent.vue?vue&type=script&lang=ts"
export * from "./ChatContent.vue?vue&type=script&lang=ts"
import style0 from "./ChatContent.vue?vue&type=style&index=0&id=167e36b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e36b0",
  null
  
)

export default component.exports